// /*jslint browser: true */

// Lenis
const lenis = new Lenis({ lerp: 0.2 });

lenis.on('scroll', () => ScrollTrigger.update());

function raf(time) { 
  lenis.raf(time); 
  requestAnimationFrame(raf); 
}
requestAnimationFrame(raf);

lenis.stop();

// GSAP Defaults
gsap.defaults({ ease: 'quint.out', duration: 0.5 });

// Menu Active Section
function highlightActiveLink() {
  // Get all the menu links and sections
  const menuLinks = document.querySelectorAll('.anchor-link');
  const sections = document.querySelectorAll('article > section');

  // Create a ScrollTrigger for each section
  sections.forEach(section => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top center',
      end: 'bottom center',
      onEnter: () => setActiveLink(section),
      onEnterBack: () => setActiveLink(section),
      onLeave: () => removeActiveLink(section),
      onLeaveBack: () => removeActiveLink(section),
    });
  });

  // Set active class to the corresponding menu link
  function setActiveLink(section) {
    menuLinks.forEach(link => {
      if (link.getAttribute('href').substring(1) === section.id) {
        link.classList.add('active');
      }
    });
  }

  // Remove active class from the menu link
  function removeActiveLink(section) {
    menuLinks.forEach(link => {
      if (link.getAttribute('href').substring(1) === section.id) {
        link.classList.remove('active');
      }
    });
  }
}

// Functions for Module: Intro
function animateIntro(section) {
  const heroImage = section.querySelector('.hero-image img');
  const heroLogoImg = section.querySelector('.hero-logo img');
  const headerLinks = document.querySelectorAll('#menu-main-nav li');

  // Set initial states
  gsap.set(heroImage, { opacity: 0 });
  gsap.set(heroLogoImg, { opacity: 0, scale: 1.1 });
  gsap.set(headerLinks, { yPercent: 100 });

  // Parallax Animation for Hero Image with Hero Logo halfway reveal
  // Combined intro animations for hero image and header links
  const introTimeline = gsap.timeline({ paused: true })
    .to(heroImage, { opacity: 1, duration: 1 }, '1')
    .to(headerLinks, { yPercent: 0, stagger: 0.1, duration: 1 }, '1.5');

  // Logo reveal animation
  const logoTimeline = gsap.timeline({ paused: true })
    .to(heroLogoImg, { opacity: 1, scale: 1, duration: 1 });

  // Main GSAP animation for hero image with ScrollTrigger
  gsap.to(heroImage, {
    willChange: 'transform',
    scale: 1,
    ease: 'none',
    scrollTrigger: {
      trigger: section,
      start: 'top bottom',
      end: 'center top',
      scrub: true,
      invalidateOnRefresh: true,
      immediateRender: false,
      onEnter: () => {
        introTimeline.play();
      },
      onUpdate: (self) => {
        const halfwayPoint = 0.7; // halfway through the progress
        const progress = self.progress;

        // Toggle the logo reveal timeline based on progress
        if (progress >= halfwayPoint) {
          logoTimeline.timeScale(1).play();
        } else {
          logoTimeline.timeScale(3).reverse();
        }
      },
      onLeaveBack: () => {
        logoTimeline.timeScale(3).reverse(); // Ensure logo hides when scrolling back
      },
    },
  });

}

//Functions for Parallax Banners
function animateParallaxBanners(section) {
  const image = section.querySelector('img');
  const parallax = 10;
  gsap.fromTo(image, {
      'will-change': 'transform', 
      yPercent:-parallax, 
    }, {
      yPercent: parallax,
      ease:'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function() {

  // Start NProgress when the page starts loading
  NProgress.configure({  parent: '#progress-bar' }).start();

  gsap.to('#loader .bg-text', {
    opacity:1, scale:1, duration:0.8, ease:'power1.inOut',
  });

  // Reveal Hero
  const hero = document.getElementById('intro');

  const revealPage = () => {
    gsap.to("#loader", {
      clipPath: 'inset(100% 0 0 0)',
      duration: 1,
      ease: 'quint.inOut',
      onStart: () => {
        animateIntro(hero);
      },
      onComplete: () => {
        loader.remove();
        lenis.start();
      },
    });
  };

  window.addEventListener("load", () => {
    setTimeout(() => {
      NProgress.done();
      revealPage();
    }, 1000);
  });

  highlightActiveLink();


  // Bigger Picture
  const bp = BiggerPicture({ target: document.body });
  
  function openBiggerPicture(e, items, video) {
    e.preventDefault();

    if (video) {
      video.pause();
    }

    bp.open({
      items: items,
      el: e.currentTarget,
      scale: 0.9,
      maxZoom: 1,
      intro: 'fadeup',
      onClose: () => {
        if (video) {
          video.play();
        }
      }
    });
  }

  const imageLinks = document.querySelectorAll('.gallery-list a');
  const videoLinks = document.querySelectorAll('.lb-link');
  imageLinks.forEach(link => 
    link.addEventListener('click', e => 
      openBiggerPicture(e, imageLinks)
    )
  );
  videoLinks.forEach(link => 
    link.addEventListener('click', e => 
      openBiggerPicture(e, e.currentTarget)
    )
  );

  // Module: Parallax Banners
  gsap.utils.toArray('.parallax').forEach(section => { 
    animateParallaxBanners(section) 
  });

});